export default __webpack_public_path__ + "static/media/vaultDark.0b48a8d4.svg";